const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.03 18.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.53,15.09H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0h19a.5.5,0,0,1,.5.5V14.59A.5.5,0,0,1,19.53,15.09ZM1,14.09H19V1H1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 11.34,
    width: 19.03,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.35,
    y: 14.59,
    width: 1,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.69,
    y: 14.59,
    width: 1,
    height: 4.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.92,
    y: 17.93,
    width: 10.18,
    height: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.2d25cb0e5b7160d1d6ce24627cb32e83.svg";
export { ForwardRef as ReactComponent };